export enum ProjectState 
{
    InProgress = 1,
    InHold = 2, 
    cancelled =3,
    Finished = 4
}